import React from 'react';
import styled from 'styled-components';

const COLOR = '#dedede';

const DragAndDropOverlayContainer = styled.div<{ visible: boolean }>`
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  background: rgba(0, 0, 0, 0.4);
  border: 6px ${COLOR} dashed;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const DragAndDropHint = styled.span`
  color: ${COLOR};
  font-size: 3vw;
  text-align: center;
  margin: 5px;
`;

export interface DragAndDropOverlayProps {
  visible?: boolean;
}

export const DragAndDropOverlay = ({ visible = true }: DragAndDropOverlayProps) => (
  <DragAndDropOverlayContainer visible={visible}>
    <DragAndDropHint>Drag and drop attachments here</DragAndDropHint>
  </DragAndDropOverlayContainer>
);
